import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import am4themes_dark from '@amcharts/amcharts4/themes/dark';

@Component({
  selector: 'app-amcharts-gauge',
  templateUrl: './amcharts-gauge.component.html',
  styleUrl: './amcharts-gauge.component.scss'
})
export class AmchartsGaugeComponent implements OnInit, OnDestroy {
  private chart: am4charts.GaugeChart | undefined;

  constructor(private zone: NgZone) { }

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      // Themes
      am4core.useTheme(am4themes_animated);
      am4core.useTheme(am4themes_dark);

      // Create chart
      let chart = am4core.create("chartdiv", am4charts.GaugeChart);
      chart.innerRadius = -15;

      // ⚡ Use AxisRendererCircular and ValueAxis<AxisRendererCircular>
      let axis = chart.xAxes.push(
        new am4charts.ValueAxis<am4charts.AxisRendererCircular>()
      );
      axis.min = 0;
      axis.max = 1000000;
      axis.strictMinMax = true;
      axis.numberFormatter.numberFormat = "#a";

      // Shadow
      let ds = new am4core.DropShadowFilter();
      ds.blur = 10;
      ds.opacity = 0.5;
      axis.filters.push(ds);

      // Gradient stroke
      let gradient = new am4core.LinearGradient();
      gradient.stops.push({ color: am4core.color("green") });
      gradient.stops.push({ color: am4core.color("yellow") });
      gradient.stops.push({ color: am4core.color("red") });

      axis.renderer.line.stroke = gradient;
      axis.renderer.line.strokeWidth = 20;
      axis.renderer.line.strokeLinecap = "round";
      axis.renderer.line.strokeOpacity = 1;

      axis.renderer.grid.template.disabled = true;

      // Hand
      let hand = chart.hands.push(new am4charts.ClockHand());
      hand.radius = am4core.percent(102);
      hand.startWidth = 16;
      hand.pin.radius = 8;
      hand.parent.zIndex = 100;

      // Animate hand
      setInterval(() => {
        hand.showValue(Math.random() * 1000000, 1000, am4core.ease.cubicOut);
      }, 2000);

      this.chart = chart;
    });
  }

  ngOnDestroy(): void {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }
}